// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"81":"2acf0d1d","133":"cba1fb2b","155":"3b7ffbd5","557":"da6eeeed","560":"bee2b9a8","621":"7f7bf9bc","702":"1ff7c62a","763":"4a5e75a0","859":"571b0bab"}[chunkId] + ".chunk.js";
};